<h2 mat-dialog-title i18n="@@section.signInMethods.selectContactEmail.title">Confirm contact email</h2>
<div mat-dialog-content>
  <p i18n="@@section.signInMethods.selectContactEmail.hint">
    Before we remove this login method, please confirm the email address that we should use to contact you. Important messages such as purchase confirmations and account information will be sent there.
  </p>

  <form [formGroup]="form">
    <mat-form-field appearance="fill" style="width: 100%">
      <mat-label i18n="@@section.signInMethods.selectContactEmail.label">New contact email</mat-label>
      <mat-select [formControlName]="SelectContactEmailForm.FIELD_EMAIL">
        <mat-option *ngFor="let e of data.availableEmails" [value]="e">{{ e }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" i18n="@@common.cancel">
    Cancel
  </button>
  <button mat-flat-button color="primary" (click)="confirm()" [disabled]="form.invalid" i18n="@@common.confirm">
    Confirm
  </button>
</div>
